// IEPS del vino. El precio de lista es antes de impuestos.
//   IEPS  = importe de cada renglon x tasa del vino, ya con descuento
//   IVA   = (subtotal - descuento + IEPS) x tasa de IVA
//   Total = subtotal - descuento + IEPS + IVA + extras (flete, comisiones)
import axios from "axios";

export const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export const iepsRenglon = (importe, tasa, descuentoPct = 0) =>
  (num(importe) * num(tasa) * (1 - num(descuentoPct) / 100)) / 100;

export function calculaDocumento(lineas, { descuento = 0, impuesto = 0, extras = 0 } = {}) {
  const subTotal = lineas.reduce((t, l) => t + num(l.total), 0);
  const descuentoNumero = (subTotal * num(descuento)) / 100;
  const ieps = lineas.reduce((t, l) => t + iepsRenglon(l.total, l.tasaIEPS, descuento), 0);
  const iva = (num(impuesto) * (subTotal - descuentoNumero + ieps)) / 100;
  const total = subTotal - descuentoNumero + ieps + iva + num(extras);
  return { subTotal, descuentoNumero, ieps, iva, total };
}

// Mapa { idArticulo: tasaIEPS } para capturar la tasa vigente al vender
export async function cargaTasasIEPS(urlArticulos) {
  const { data } = await axios.get(`${urlArticulos}Activos`, {
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  });
  const mapa = {};
  data.forEach((a) => { mapa[a._id] = num(a.tasaIEPS); });
  return mapa;
}
